var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, Card, getTestId, isValidObject, Switch, Typography, useBreakpoint } from '@airtel/air-design-system';
import { useEffect } from 'react';
import { View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { OfferStripWidget } from '../offer-strip-widget';
import { ScrollLinkListWidget } from '../scroll-link-list-widget';
import { getStatusCardWidgetStyles } from './StatusCardWidgetStyles';
import { StatusCardAnimatedText } from './components/status-card-animated-text';
import { StatusCardCollapsibleSection } from './components/status-card-collapsible-section';
import { StatusCardImageSection } from './components/status-card-image-section';
import { StatusCardLoaderSection } from './components/status-card-loader-section';
import { StatusCardSvgSection } from './components/status-card-svg-section';
import { StatusCardTimerText } from './components/status-card-timer-text';
import { CalloutWidget } from '../callout-widget';
import { TypographyWidget } from '../typography-widget';
export var StatusCardWidgetComponent = props => {
  var _props$withCard = props.withCard,
    withCard = _props$withCard === void 0 ? false : _props$withCard,
    _props$title = props.title,
    title = _props$title === void 0 ? {} : _props$title,
    _props$subtitle = props.subtitle,
    subtitle = _props$subtitle === void 0 ? {} : _props$subtitle,
    _props$animatedNumber = props.animatedNumber,
    animatedNumber = _props$animatedNumber === void 0 ? 0 : _props$animatedNumber,
    _props$hintText = props.hintText,
    hintText = _props$hintText === void 0 ? '' : _props$hintText,
    _props$ctaTitle = props.ctaTitle,
    ctaTitle = _props$ctaTitle === void 0 ? '' : _props$ctaTitle,
    _props$ctaOnPress = props.ctaOnPress,
    ctaOnPress = _props$ctaOnPress === void 0 ? {} : _props$ctaOnPress,
    _props$primaryCtaTitl = props.primaryCtaTitle,
    primaryCtaTitle = _props$primaryCtaTitl === void 0 ? '' : _props$primaryCtaTitl,
    _props$primaryCtaOnPr = props.primaryCtaOnPressMetaData,
    primaryCtaOnPressMetaData = _props$primaryCtaOnPr === void 0 ? {} : _props$primaryCtaOnPr,
    _props$primaryButtonV = props.primaryButtonVersion,
    primaryButtonVersion = _props$primaryButtonV === void 0 ? 'variable-width' : _props$primaryButtonV,
    _props$primaryButtonT = props.primaryButtonType,
    primaryButtonType = _props$primaryButtonT === void 0 ? 'primary' : _props$primaryButtonT,
    _props$ctaDirection = props.ctaDirection,
    ctaDirection = _props$ctaDirection === void 0 ? 'row' : _props$ctaDirection,
    _props$collapsibleDat = props.collapsibleData,
    collapsibleData = _props$collapsibleDat === void 0 ? [] : _props$collapsibleDat,
    _props$collapsibleCta = props.collapsibleCtaData,
    collapsibleCtaData = _props$collapsibleCta === void 0 ? {} : _props$collapsibleCta,
    _props$timerProps = props.timerProps,
    timerProps = _props$timerProps === void 0 ? {} : _props$timerProps,
    id = props.id,
    onUserAction = props.onUserAction,
    _props$statusCardImag = props.statusCardImage,
    statusCardImage = _props$statusCardImag === void 0 ? {} : _props$statusCardImag,
    _props$svg = props.svg,
    svg = _props$svg === void 0 ? {} : _props$svg,
    _props$loader = props.loader,
    loader = _props$loader === void 0 ? {} : _props$loader,
    _props$showCollapsibl = props.showCollapsible,
    showCollapsible = _props$showCollapsibl === void 0 ? true : _props$showCollapsibl,
    _props$type = props.type,
    type = _props$type === void 0 ? 'image' : _props$type,
    _props$buttonVersion = props.buttonVersion,
    buttonVersion = _props$buttonVersion === void 0 ? 'variable-width' : _props$buttonVersion,
    _props$buttonType = props.buttonType,
    buttonType = _props$buttonType === void 0 ? 'tertiary' : _props$buttonType,
    _props$showAsFullPage = props.showAsFullPage,
    showAsFullPage = _props$showAsFullPage === void 0 ? false : _props$showAsFullPage,
    _props$absolute = props.absolute,
    absolute = _props$absolute === void 0 ? false : _props$absolute,
    _props$offerStripProp = props.offerStripProps,
    offerStripProps = _props$offerStripProp === void 0 ? {} : _props$offerStripProp,
    style = props.style,
    benefitsListData = props.benefitsListData,
    testID = props.testID,
    buttonWidgetProps = props.buttonWidgetProps,
    switchWidgetProps = props.switchWidgetProps,
    expandedCollapsableSection = props.expandedCollapsableSection,
    onMountHandler = props.onMountHandler,
    calloutWidgetProps = props.calloutWidgetProps,
    restProps = __rest(props, ["withCard", "title", "subtitle", "animatedNumber", "hintText", "ctaTitle", "ctaOnPress", "primaryCtaTitle", "primaryCtaOnPressMetaData", "primaryButtonVersion", "primaryButtonType", "ctaDirection", "collapsibleData", "collapsibleCtaData", "timerProps", "id", "onUserAction", "statusCardImage", "svg", "loader", "showCollapsible", "type", "buttonVersion", "buttonType", "showAsFullPage", "absolute", "offerStripProps", "style", "benefitsListData", "testID", "buttonWidgetProps", "switchWidgetProps", "expandedCollapsableSection", "onMountHandler", "calloutWidgetProps"]);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var statusCardWidgetStyles = getStatusCardWidgetStyles(props, isLargeScreen);
  var Container = withCard ? Card : View;
  var containerStyles = withCard && statusCardWidgetStyles.cardPadding;
  var showAsFullPageStyles = showAsFullPage && statusCardWidgetStyles.showAsFullPage;
  var absoluteStyles = absolute && statusCardWidgetStyles.absolute;
  useEffect(() => {
    onMountHandler === null || onMountHandler === void 0 ? void 0 : onMountHandler();
  }, []);
  return _jsxs(Container, Object.assign({
    style: [containerStyles, showAsFullPageStyles, absoluteStyles, style]
  }, getTestId(testID, 'container'), restProps, {
    children: [_jsxs(View, Object.assign({
      style: [withCard && statusCardWidgetStyles.contentContainer]
    }, {
      children: [!!type && _jsxs(View, Object.assign({
        style: statusCardWidgetStyles.imageContainer
      }, {
        children: [type === 'image' && _jsx(StatusCardImageSection, Object.assign({}, getTestId(testID, 'statusCardImage'), statusCardImage)), type === 'svg' && _jsx(StatusCardSvgSection, Object.assign({}, getTestId(testID, 'svg'), svg)), type === 'loader' && _jsx(StatusCardLoaderSection, Object.assign({}, getTestId(testID, 'loader'), loader))]
      })), !!title && !!Object.keys(title).length && _jsx(StatusCardAnimatedText, Object.assign({}, getTestId(testID, 'title'), title, {
        withNumberSeparator: true,
        animatedNumber: animatedNumber
      })), !!subtitle && !!Object.keys(subtitle).length && _jsx(View, Object.assign({
        style: [statusCardWidgetStyles.subTitle, subtitle.style]
      }, {
        children: _jsx(TypographyWidget, Object.assign({}, getTestId(testID, 'subtitle'), {
          color: BLACK_700
        }, subtitle, {
          style: statusCardWidgetStyles.textCenter,
          type: isLargeScreen ? 'body-para-md' : 'body-para-sm',
          onUserAction: onUserAction
        }))
      })), isValidObject(offerStripProps) && _jsx(OfferStripWidget, Object.assign({}, getTestId(testID, 'offer'), offerStripProps, {
        style: [statusCardWidgetStyles.offerStrip, offerStripProps.style]
      })), isValidObject(calloutWidgetProps) && _jsx(CalloutWidget, Object.assign({}, getTestId(testID, 'callout'), calloutWidgetProps, {
        style: [statusCardWidgetStyles.callout, calloutWidgetProps.style],
        onUserAction: onUserAction
      })), !!timerProps && !!Object.keys(timerProps).length && _jsx(StatusCardTimerText, Object.assign({}, getTestId(testID, 'timer'), timerProps, {
        onUserAction: onUserAction
      })), !!hintText && _jsx(Typography, Object.assign({}, getTestId(testID, 'hintText'), {
        style: [statusCardWidgetStyles.hint, statusCardWidgetStyles.textCenter],
        type: isLargeScreen ? 'body-single-line-sm' : 'body-single-line-xs',
        color: BLACK_700,
        text: hintText
      })), (!!primaryCtaTitle || !!ctaTitle) && _jsx(ButtonWidget, Object.assign({}, getTestId(testID, 'buttonContainer'), buttonWidgetProps, {
        style: [statusCardWidgetStyles.buttonContainer, buttonWidgetProps === null || buttonWidgetProps === void 0 ? void 0 : buttonWidgetProps.style],
        direction: ctaDirection,
        onLeftCtaPress: primaryCtaOnPressMetaData,
        onRightCtaPress: ctaOnPress,
        leftCta: Object.assign(Object.assign(Object.assign({
          size: isLargeScreen ? 'lg' : 'md',
          buttonType: primaryButtonType,
          version: primaryButtonVersion,
          title: primaryCtaTitle
        }, getTestId(testID, 'leftCta')), buttonWidgetProps === null || buttonWidgetProps === void 0 ? void 0 : buttonWidgetProps.leftCta), restProps),
        rightCta: Object.assign(Object.assign(Object.assign({
          size: isLargeScreen ? 'lg' : 'md',
          buttonType: buttonType,
          version: buttonVersion,
          title: ctaTitle
        }, getTestId(testID, 'rightCta')), buttonWidgetProps === null || buttonWidgetProps === void 0 ? void 0 : buttonWidgetProps.rightCta), restProps),
        onUserAction: onUserAction
      }))]
    })), !!isValidObject(switchWidgetProps) && _jsx(View, Object.assign({
      style: Object.assign({}, (switchWidgetProps === null || switchWidgetProps === void 0 ? void 0 : switchWidgetProps.containerStyles) || {})
    }, {
      children: _jsx(Switch, Object.assign({}, switchWidgetProps, {
        onPress: () => (switchWidgetProps === null || switchWidgetProps === void 0 ? void 0 : switchWidgetProps.onPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, switchWidgetProps === null || switchWidgetProps === void 0 ? void 0 : switchWidgetProps.onPress), {
          props
        }))
      }))
    })), !!showCollapsible && _jsx(StatusCardCollapsibleSection, Object.assign({}, getTestId(testID, 'collapsible_section'), {
      id: id,
      collapsibleData: collapsibleData,
      collapsibleCtaData: collapsibleCtaData,
      isExpanded: expandedCollapsableSection,
      onUserAction: onUserAction
    })), !!benefitsListData && _jsx(ScrollLinkListWidget, Object.assign({}, getTestId(testID, 'benefits'), {
      onUserAction: onUserAction
    }, benefitsListData))]
  }));
};
StatusCardWidgetComponent.genericRendererKey = 'AirStatusCardWidget';